export const PROJECT_CARD_MIN_WIDTH = 265;
export const PROJECT_CARD_MAX_WIDTH = 347;

export const RECENT_PROJECT_CARD_MAX_WIDTH = 314;

export const PROJECT_CARD_WIDTH = 265;
export const PROJECT_CARD_HEIGHT = 253;
export const PROJECT_CONTENT_CARD_HEIGHT = 188;

export const IMAGE_WIDTH = 75.75;
export const IMAGE_HEIGHT = 75.75;
